export default __webpack_public_path__ + "static/media/gericht.ac5d3ce2.png";